import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { OnboardingProcessStageSubmittedDocuments } from '@interfaces/a-organizar/onboardingCompanyInformation';

type DocumentStatusKey = 'approved' | 'rejected' | 'pending' | 'unknown';

@Component({
  selector: 'app-analysis-document-pill',
  standalone: true,
  imports: [CommonModule, TooltipModule],
  templateUrl: './analysis-document-pill.component.html',
  styleUrls: ['./analysis-document-pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalysisDocumentPillComponent {
  @Input({ required: true }) document!: OnboardingProcessStageSubmittedDocuments;
  @Input() showYear = false;
  @Input() submissionTooltip = '';
  @Input() analysisTooltip = '';
  @Input() statusLabels: { approved: string; rejected: string; pending: string } = {
    approved: '',
    rejected: '',
    pending: '',
  };
  @Output() documentSelect = new EventEmitter<void>();

  get statusKey(): DocumentStatusKey {
    switch (this.document.statusAnalysisDocuments) {
      case 'Approved':
        return 'approved';
      case 'Rejected':
        return 'rejected';
      case 'Pending':
      case 'SubmittedForApproval':
        return 'pending';
      default:
        return 'unknown';
    }
  }

  get statusLabel(): string {
    switch (this.statusKey) {
      case 'approved':
        return this.statusLabels.approved;
      case 'rejected':
        return this.statusLabels.rejected;
      case 'pending':
        return this.statusLabels.pending;
      default:
        return this.document.statusAnalysisDocuments;
    }
  }

  get iconSource(): string {
    return `assets/images/icons/icon-${this.document.fileExtension}.svg`;
  }
}
